import { createContext, useContext } from 'react';

export type LearnerAuth = {
  getToken: () => Promise<string | null>;
  isLoaded: boolean;
  isSignedIn: boolean;
  signOut: () => Promise<void>;
};

const LearnerAuthContext = createContext<LearnerAuth | null>(null);

export function LearnerAuthProvider({
  auth,
  children,
}: React.PropsWithChildren<{ auth: LearnerAuth | null }>) {
  return <LearnerAuthContext.Provider value={auth}>{children}</LearnerAuthContext.Provider>;
}

export function useLearnerAuth() {
  return useContext(LearnerAuthContext);
}
